<div
  *ngIf="progressLoaderService.activeLoader$ | async as activeLoader"
  class="progress-overlay d-flex justify-content-center align-items-center text-center"
>
  <div class="progress-container">
    <img src="assets/preload_common.svg" height="80px" width="80px" />
    <h2>
      {{ activeLoader.message }}<span class="ellipse">{{ ellipsis }}</span>
    </h2>
  </div>
</div>
